import request from '@/utils/request';

export const getOpenId = (data) => {
    return request({
        method: "POST",
        url: "/secHome/getOpenId",
        data

    })
}
//抢购-秒杀

export const doSecKill = (data) => {
    return request({
        method: "POST",
        url: "/secKill/doSecKill",
        data

    });
};
export const getSecOrderInfo = (params) => {
    return request({
        method: "GET",
        url: "/secHome/getSecOrderInfo",
        params

    });
};
export const getOrderList = (params) => {
    return request({
        method: "GET",
        url: "/secHome/getOrderList",
        params

    });
};


export const getSecOrderList = (params) => {
    return request({
        method: "GET",
        url: "/secHome/getSecOrderList",
        params

    });
};
// /secHome/

export const confirmOrder = (data) => {
    return request({
        method: "POST",
        url: "/secHome/confirmOrder",
        data

    });
};
export const cancelOrder = (data) => {
    return request({
        method: "POST",
        url: "/secHome/cancelOrder",
        data

    });
};

export const payOrder = (data) => {
    return request({
        method: "POST",
        url: "/secHome/payOrder",
        data

    });
};

export const testPay = (data) => {
    return request({
        method: "POST",
        url: "/secHome/testPay",
        data

    });
};

export const getRecordList = () => {
    return request({
        method: "GET",
        url: "/secHome/getRecordList",

    });
};

export const getStartTime = () => {
    return request({
        method: "GET",
        url: "/secHome/getStartTime",

    });
};
export const getGoodsInfo = () => {
    return request({
        method: "GET",
        url: "/secHome/getGoodsInfo",

    });
};
export const getSkillType = () => {
    return request({
        method: "GET",
        url: "/secHome/getSkillType",

    });
};

//商品详情
export const getGoodDetail = (params) => {
    return request({
        method: "GET",
        url: "/secHome/getGoodDetail",
        params
    })
};

//两个实体
export const getGoodsInfoList = goodId => {
    return request({
        methods: "GET",
        url: "/secHome/getGoodsInfoList", params: {goodId}
    })
}

export default {
    doSecKill,
    getSecOrderInfo,
    getOrderList,
    getSecOrderList,
    confirmOrder,
    cancelOrder,
    payOrder,
    testPay,
    getRecordList,
    getStartTime,
    getGoodsInfo,
    getSkillType,
    getGoodDetail,
    getGoodsInfoList
}


